"use client"
// src/layouts/slideshow/slideshow.tsx
import Divider from "@a24/ui/Divider";
import Link from "@a24/ui/Link";
import SanityImage from "@a24/ui/SanityImage";
import Slider from "@a24/ui/Slider";
import Title from "@a24/ui/Title";
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Slideshow = ({
  cta,
  images,
  className = "",
  id,
  title
}) => {
  if (!images) return null;
  const imagesRef = useRef([]);
  useEffect(() => {
    if (images) {
      imagesRef.current = imagesRef.current.slice(0, images.length);
    }
  }, [images]);
  return /* @__PURE__ */ jsxs("div", { className: `grid grid-cols-12 gap-x-3 ${className}`, id, children: [
    /* @__PURE__ */ jsxs("div", { className: "col-span-full content-end row-span-1 row-start-1 md:col-span-8 md:col-start-1 max-md:px-6 max-2xl:px-16", children: [
      title && /* @__PURE__ */ jsx(
        Title,
        {
          className: "heading-md pb-10 md:pb-6",
          level: "h2",
          text: title
        }
      ),
      cta && /* @__PURE__ */ jsx(
        Link,
        {
          className: "button-secondary w-fit mb-4 relative md:mt-[0.375rem] md:mb-[1.625rem]",
          href: cta.destination || "#",
          openNewTab: cta.isExternal,
          tracking: {
            label: cta.label,
            layout: "Slideshow"
          },
          children: cta.label
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "col-span-full row-span-1 row-start-2 max-md:px-6 max-2xl:px-16", children: /* @__PURE__ */ jsx(Divider, { className: "divider-default mb-6 md:mb-8" }) }),
    /* @__PURE__ */ jsx(
      Slider,
      {
        navigationClassName: "col-span-full content-end row-span-1 row-start-1 text-end md:col-span-3 md:col-start-10 max-md:pr-6 max-2xl:pr-16",
        sliderClassName: "no-scroll-bar full-viewport-width col-span-full row-start-3 grid gap-x-2 grid-flow-col overflow-x-auto relative snap-x scroll-p-[var(--outter-gutter)] snap-mandatory lg:gap-x-4",
        slidesRef: imagesRef.current,
        children: images.map((image, index) => {
          if (image.image?.asset?._ref === void 0)
            return null;
          const height = 500;
          const width = image.orientation === "portrait" ? 400 : image.orientation === "landscape" ? 750 : 500;
          const indentFirstItem = index === 0 ? "ml-[var(--outter-gutter)]" : "";
          const indentLastItem = index === images.length - 1 ? "mr-[var(--outter-gutter)]" : "";
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: `${className} row-start-1 row-end-2 grow-1 shrink-0 box-border snap-start ${indentFirstItem} ${indentLastItem}`,
              "data-caption": image.caption,
              ref: (el) => {
                imagesRef.current[index] = el;
              },
              children: /* @__PURE__ */ jsx(
                SanityImage,
                {
                  className: "rounded-sm overflow-hidden",
                  imageClassName: "w-auto max-w-none h-[11rem] md:h-[31.25rem]",
                  sanityImageSourceData: image.image,
                  height,
                  width
                }
              )
            },
            image.image?.asset?._ref
          );
        })
      }
    )
  ] });
};
var slideshow_default = Slideshow;

export {
  slideshow_default
};
